import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const SkipLink = styled.a`
  left: 50%;
  position: fixed;
  transform: translateY(-100%);
  top: 0;
  padding: 5px;

  &:focus {
    transform: translateY(0);
    z-index: 1;
  }
`;

const mapStateToProps = ({ language: { 'returns.general.skip_to_content': text } }) => ({
  text,
});

const SkipContent = ({ text }) => (
  <SkipLink href="#main" tabindex="-1">
    {text}
  </SkipLink>
);

SkipContent.propTypes = {
  text: PropTypes.string.isRequired,
};

export default connect(mapStateToProps)(SkipContent);
